import { render, staticRenderFns } from "./CostChip.vue?vue&type=template&id=57fdfb28"
import script from "./CostChip.vue?vue&type=script&lang=js"
export * from "./CostChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports